import apiClient from "../network/apiClient";

class CartApiProvider {
  async addToCart(input) {
    try {
      const response = await apiClient.post("add-cart", input);
      const message = response.data?.message ?? "Something went wrong";
      if ((response.status == 200 || response.status == 201) && response) {
        window.dispatchEvent(new Event("cartUpdated"));
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }
  async getCart(userId, params = {}) {
    try {
      const response = await apiClient.get(`cart-list/${userId}`, { params });
      const message = response.data?.message ?? "Something went wrong";
      if ((response.status == 200 || response.status == 201) && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }

  async removeCartItem(cartId, productId) {
    try {
      const response = await apiClient.delete(`cart/${cartId}?productId=${productId}`);
      const message = response.data?.message ?? "Something went wrong";
      if ((response.status == 200 || response.status == 201) && response) {
        window.dispatchEvent(new Event("cartUpdated"));
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }
  async getUserDetails(input) {
    try {
      const response = await apiClient.get("cart-detail/get-user-details");
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201 && response) {
        // notification.showAlertNotification(response.data.message, true);
        return {
          status: response.status,
          response: response.data
        };
      } else {
        // notification.showAlertNotification(message, false);
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: []
      };
    }
  }
}
const apiCart = new CartApiProvider()
export default apiCart